module.exports = __webpack_public_path__ + "img/selected0-min.7588e8ab.png";